"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ModifyCell;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _assignButton = _interopRequireDefault(require("./styled/assignButton"));

function ModifyCell(props) {
  var _onClick = props.onClick,
      value = props.value,
      row = props.row;
  var buttonText = value ? 'Change' : 'Assign';
  return _react["default"].createElement(_assignButton["default"], {
    onClick: function onClick() {
      return _onClick(row.databaseField);
    }
  }, buttonText);
}

ModifyCell.propTypes = {
  onClick: _propTypes["default"].func,
  value: _propTypes["default"].string,
  row: _propTypes["default"].object.isRequired
};
ModifyCell.defaultProps = {
  onClick: function onClick() {},
  value: ''
};